import { useEffect } from 'react';

/**
 * 🟥 FIX scroll cell — Habilita scroll natural del documento mientras la
 * pagina actual esta montada. La app base tiene `body { overflow:hidden }`
 * y `.App { height:100dvh; overflow:hidden }` para que el chat use scroll
 * interno; este hook aniade la clase `allow-page-scroll` al <html> y deja
 * que las reglas CSS con `!important` pisen overflow/height de forma
 * robusta — evita race conditions con otros effects (ej: ConsentGate
 * scroll-lock) que antes manipulaban inline styles y se pisaban entre si.
 */
export default function useEnableBodyScroll() {
  useEffect(() => {
    const html = document.documentElement;
    html.classList.add('allow-page-scroll');
    return () => {
      html.classList.remove('allow-page-scroll');
    };
  }, []);
}
